import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

// Imagens
import logo from '../../../assets/images/logo-meia-entrada.svg';

export default class Header extends Component {
  render() {

    return (
      <header>
        <nav className="navbar navbar-expand-xl navbar-dark fixed-top mainNavbar py-0">
          <div className="container">
            <NavLink className="navbar-brand logo-link py-0" exact to="/" aria-label='Logo'>
              <img src={logo} height="80" className="d-inline-block align-top" alt="Logo"/>
            </NavLink>
            <button className="navbar-toggler " type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"/>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto">


                <li className="nav-item dropdown">
                  <NavLink className="nav-link dropdown-toggle" id='navbarDropdownLei' strict to="/lei"
                           activeClassName="active" title='O que diz a lei' data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false">
                    Lei da Meia-entrada
                  </NavLink>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownLei">
                    <NavLink exact to='/lei' className="dropdown-item" activeClassName="active">A Lei</NavLink>
                    <NavLink exact to='/lei/padraonacional' className="dropdown-item" activeClassName="active">Padrão
                      Nacional</NavLink>
                    <NavLink exact to='/lei/comocomunicar' className="dropdown-item" activeClassName="active">Como
                      Funciona</NavLink>
                  </div>
                </li>


                <li className="nav-item dropdown">
                  <NavLink className="nav-link dropdown-toggle" id='navbarDropdownValidacao' to="/validador"
                           activeClassName="active" title='Valide a Carteira de Identificação Estudantil (CIE)'
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Validação</NavLink>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownValidacao">
                    <NavLink exact to='/validador/itens-de-seguranca' className="dropdown-item" activeClassName="active">Itens de
                      segurança</NavLink>
                {/* <NavLink exact to='/validador/integracao' className="dropdown-item" activeClassName="active">Integração</NavLink> */}
                  </div>
                </li>


                <li className="nav-item">
                  <NavLink className="nav-link" exact to="/chaves-publicas" activeClassName="active"
                           title='Validador oficial'>Chaves públicas</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" exact to="/perguntas-e-respostas" activeClassName="active"
                           title='Perguntas e respostas'>FAQ</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" exact to="/noticias" activeClassName="active"
                           title='Notícias'>Notícias</NavLink>
                </li>

              </ul>
            </div>
          </div>
        </nav>
      </header>


    )
  }
}


// WEBPACK FOOTER //
// ./src/components/views/Shared/_Header.js